var map = {
	"./ae.svg": 1104,
	"./ae1.svg": 1105,
	"./cn.svg": 1106,
	"./gb.svg": 1107
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country ^\.\/.*$
// module id = 172
// module chunks = 1